module.exports = __webpack_public_path__ + "img/p_kjfp.6f418e81.png";